import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, Package } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user === false) nav("/login");
  }, [user, nav]);

  useEffect(() => {
    if (user && user.id) {
      api.get("/orders").then((r) => { setOrders(r.data); setLoading(false); });
    }
  }, [user]);

  if (!user) return <div className="max-w-[1400px] mx-auto px-5 py-20 font-mono">Loading_</div>;

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-12 md:py-16" data-testid="account-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b-2 border-border pb-6 mb-10">
        <div>
          <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tighter">Hey, {user.name?.split(" ")[0] || "Rebel"}</h1>
          <p className="font-mono text-sm text-muted-foreground mt-2" data-testid="account-email">{user.email}</p>
        </div>
        <div className="flex gap-3">
          {user.role === "admin" && (
            <Link to="/admin" className="font-outfit font-bold uppercase text-xs tracking-widest border-2 border-border px-4 py-2.5 hover:bg-primary hover:text-black transition-colors">Admin Panel</Link>
          )}
          <button onClick={() => { logout(); nav("/"); }} data-testid="logout-btn" className="font-outfit font-bold uppercase text-xs tracking-widest border-2 border-border px-4 py-2.5 hover:bg-secondary hover:border-secondary hover:text-white hover:text-white transition-colors flex items-center gap-2">
            <LogOut size={14} /> Log Out
          </button>
        </div>
      </div>

      <h2 className="font-outfit font-bold uppercase tracking-widest text-sm mb-5 flex items-center gap-2"><Package size={16} /> Order History</h2>
      {loading ? (
        <p className="font-mono text-sm animate-pulse">Loading orders_</p>
      ) : orders.length === 0 ? (
        <div className="border-2 border-border p-10 text-center" data-testid="no-orders">
          <p className="font-mono text-sm text-muted-foreground">No orders yet.</p>
          <Link to="/shop" className="inline-block mt-4 bg-primary text-primary-foreground font-outfit font-bold uppercase tracking-widest text-xs px-6 py-3 border-2 border-border hover:bg-secondary hover:border-secondary hover:text-white transition-colors">Start Shopping</Link>
        </div>
      ) : (
        <div className="space-y-5">
          {orders.map((o) => (
            <div key={o.id} className="border-2 border-border" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 bg-muted px-5 py-3 border-b-2 border-border">
                <span className="font-mono text-xs uppercase tracking-widest">Order #{o.id.slice(-6)}</span>
                <span className="font-mono text-xs text-muted-foreground">{new Date(o.created_at).toLocaleDateString()}</span>
                <span className="font-outfit font-bold uppercase text-xs bg-primary text-primary-foreground px-3 py-1">{o.status}</span>
                <span className="font-anton text-xl">${o.total.toFixed(2)}</span>
              </div>
              <div className="p-5 grid gap-3">
                {o.items.map((it, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <img src={it.image} alt={it.name} className="w-12 h-14 object-cover border border-border" />
                    <div className="font-mono text-xs">
                      <p className="font-bold uppercase">{it.name}</p>
                      <p className="text-muted-foreground">{it.qty}× · {it.type === "print" ? "Print" : "Tee"}{it.size ? ` · ${it.size}` : ""}{it.color ? ` · ${it.color}` : ""}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
